<template>
  <v-card flat class="fill-height" width="100%">
    <v-app-bar extended dark color="primary">
      <v-toolbar-title>SEQF Administration</v-toolbar-title>
    </v-app-bar>
    <v-row align="center">
      <v-col class="px-6 elements" cols="6">
        <v-container>
          <v-card-title>Yrken</v-card-title>
          <v-select
            v-model="filterProfession"
            :items="professions"
            label="Välj yrke"
            persistent-hint
            return-object
            single-line
            v-on:change="changeProfession"
            class="professions mx-auto"
          ></v-select>

          <!-- <alert v-if="showAlertComp" :type="alertType" :text="alertText"></alert> -->

          <v-row>
            <v-col class>
              <ul class="py-4">
                <li
                  v-for="(item) in sections"
                  :key="item.id"
                  @click="sectionClick(item.id)"
                  class="itemSection"
                >
                  <TransformerTextField
                    label="Sektion"
                    placeholder="Sektion"
                    type="section"
                    :item="item"
                    :edit="editSection"
                    @textUpdated="reloadAfterChange"
                  />
                </li>
              </ul>
            </v-col>
          </v-row>

          <template v-if="sections.length">
            <v-card flat class="fill-height text-center">
              <v-btn
                v-if="!editSection"
                @click="editSectionClick"
                class="mx-auto"
                type="submit"
                color="primary"
              >Ändra</v-btn>
              <v-btn
                v-if="editSection"
                @click="editSectionClick"
                class="mx-auto"
                type="submit"
                color="primary"
              >Avbryt</v-btn>
            </v-card>
          </template>

          <template>
            <AddSection
              v-if="filterProfession.value!=null"
              :professionId="filterProfession.value"
              @sectionAdded="reloadAfterChange"
            ></AddSection>
          </template>
        </v-container>
      </v-col>
      <v-col cols="6" class="elements">
        <elements v-if="showElements" :section="elements" @reloadAfterChange="reloadAfterChange"></elements>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Elements from '@/components/seqfadministration/Elements.vue'
import TransformerTextField from '@/components/seqfadministration/TransformerTextField.vue'
//import Alert from '@/components/seqfadministration/Alert.vue'
import AddSection from '@/components/seqfadministration/AddSection.vue'
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import {pageSize} from '@/store/constants'
import {objectExpression} from '@babel/types'
import {ifStatement} from '@babel/types'
import {types} from 'util'

// @group Common
// SEQFadministrations component
export default {
  name: 'SEQFadministrations',
  data: () => ({
    sections: {},
    editSection: false,
    itemsPerPage: pageSize,
    professions: [],
    filterProfession: '',
    showAddSection: false,
    newSection: '',
    isRotated: false,
    showElements: false,
    elements: {},
    respons: ''
  }),
  components: {
    Elements,
    AddSection,
    TransformerTextField
  },
  computed: {    
    headers() {
      return [
        {
          text: 'Administration',
          value: 'name'
        }
      ]
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.fetchProfessions()
  },
  methods: {
    showApplication(item) {
      this.$router.push('/applications/' + item.id)
    },
    editSectionClick() {
      this.editSection = !this.editSection
    },
    filteredProfession() {
      if (this.filterProfession.value != null) {
        this.getSections(this.filterProfession.value)
      }
    },
    /**
     * @vuese
     *  Used get sections based on profession id
     */
    getSections(id, sectionId = -1) {    
      API.selectSections({professionId: Number(id)})
        .then(response => {
          this.sections = response.data      
          if (sectionId > 0) {
            this.elements = this.getElementsBySectionId(sectionId)            
          }          
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    changeProfession() {
      this.filteredProfession()
      this.showElements = false
      this.elements = {}
    },    
    sectionClick(id) {
      this.elements = this.getElementsBySectionId(id)
      this.showElements = true
    },
    reloadAfterChange(e) {      
      if (
        typeof e.sectionId == 'number' &&
        e.sectionId !== null &&
        typeof e.professionId == 'number' &&
        e.professionId !== null
      ) {
        // @vuese
        // from component AddElement
        this.getSections(e.professionId, e.sectionId) //TODO -- bug
        
      } else {        
        this.getSections(this.filterProfession.value) // from component AddSection
        this.showElements = false
      }
    },
    getElementsBySectionId(id) {
      return this.sections.find(x => x.id === id)
    },
    addClick() {
      this.isRotated = !this.isRotated
      this.showAddSection = this.isRotated
    },
     // @vuese
     // Used to list professions
    fetchProfessions() {
      API.listProfessions()
        .then(response => {
          this.professions = response.data.map(o => ({
            value: o.id,
            text: o.name
          }))
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    }
  }
}
</script>

<style scoped lang="scss">
$grey: #ccc;
$lightgrey: #f0f0f0;
$darkgrey: #333;
ul {
  list-style: none;
  li {
    width: 100%;
    height: 80px;
    border-bottom: 1px solid $grey;
    padding-left: 5px;
    display: flex;
    &:last-child {
      border: none;
    }
    &.itemSection {
      display: flex;
      justify-content: space-between;
      align-items: center;
      &:hover {
        cursor: pointer;
      }
    }
    &:hover {
      background-color: $lightgrey;
      transition: background-color 0.5s ease;
    }
  }
}
.buttons {
  display: flex;
  justify-content: flex-end;
}
.elements {
  align-self: flex-start;
}
.rotate {
  -moz-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.icons {
  .v-icon {
    width: 40px;

    &:hover {
      color: var(--v-secondary-base) !important;
      font-size: 32px;
    }
  }
}
.professions {
  width: 90%;
}
.addSection {
  display: flex;
  justify-content: flex-end;
}
</style>
